import { combineReducers } from 'redux'
import auth from './auth'
import settings from './settings'
import { LOG_OUT } from 'config/actionTypes'

const appReducer = combineReducers({
  auth,
  settings,
})

export default (state, action) => {
  if (action.type === LOG_OUT) {
    state = undefined
  }
  return appReducer(state, action)
}
